module.exports = __webpack_public_path__ + "static/media/_BID5422.fc80f55d.png";